import * as React from "react";

import {
    AppMenuItem,
    ChevronDoubleLeftIcon,
    ChevronDoubleRightIcon,
} from "../..";
import { useDeviceSize } from "../hooks";
import { useRelodeApp } from "../RelodeApp";
import { AppMenuDesktop } from "./appMenuDesktop";
import { AppMenuMobile } from "./appMenuMobile";
import { AppMenuProps } from "./appMenuProps";
import { getMenuItemsOfType } from "./utils";

const MenuToggler = () => {
    const {
        state: {
            settings: {
                user: { isMenuOpen },
            },
        },
        actions: { openMenu, closeMenu, toggleMenu },
    } = useRelodeApp();

    return (
        <AppMenuItem
            id="navMenuToggle"
            label=""
            tooltip={
                isMenuOpen ? "show less information" : "show more information"
            }
            icon={
                isMenuOpen ? (
                    <ChevronDoubleLeftIcon />
                ) : (
                    <ChevronDoubleRightIcon />
                )
            }
            action={toggleMenu}
            type="system"
        />
    );
};

export const AppMenu = (props: AppMenuProps) => {
    const { children } = props;
    const {
        state: {
            settings: {
                user: { isMenuOpen },
            },
        },
        actions: { openMenu, closeMenu, toggleMenu },
    } = useRelodeApp();

    const device = useDeviceSize();
    const onMenuItemClick = React.useCallback(
        (item: { id: string; route: string }) => {
            if (device === "mobile" && isMenuOpen) {
                closeMenu();
            }
        },
        [isMenuOpen, closeMenu, device]
    );

    // const handle
    const menu = React.useMemo(() => {
        const menuItems = getMenuItemsOfType(
            "menu",
            children,
            isMenuOpen,
            onMenuItemClick
        );
        const systemItems = getMenuItemsOfType(
            "system",
            children,
            isMenuOpen,
            onMenuItemClick
        );

        // only show menu toggler on desktop
        if (device === "desktop") {
            systemItems.push(<MenuToggler key={systemItems.length} />);
        }

        return {
            menuItems,
            systemItems,
        };
    }, [children, isMenuOpen, onMenuItemClick, device]);

    if (device === undefined) return null;

    return device === "desktop" ? (
        <AppMenuDesktop
            {...props}
            {...menu}
            isMenuOpen={isMenuOpen}
            toggleMenu={toggleMenu}
        />
    ) : (
        <AppMenuMobile
            {...props}
            {...menu}
            isMenuOpen={isMenuOpen}
            toggleMenu={toggleMenu}
        />
    );
};
